if (!customElements.get("image-with-icons")) {
  class ImageWithIcons extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setProperties();
      this.setEventListeners();

      if (!this.image.complete && this.isBlendEffect) {
        this.image.addEventListener('load', () => this.setupImageObserver.bind(this));
      } else {
        this.setupImageObserver();
      }
    }

    setProperties() {
      this.section = this.closest("section")
      this.sectionId = this.section.getAttribute("id")
      this.isBlendEffect = this.section.classList.contains("mobile-section-blending")
      this.image = this.querySelector("[data-image-with-icon]")
      this.blendComponent = this.section.querySelector("[data-blend-effect-component]")
    }

    setEventListeners() {
      if(this.isBlendEffect){
        window.addEventListener('resize', () => {
          if (window.innerWidth <= 991) {
            this.observeImageHeight(this.image);
          }
        });
      }
     
    }

    setupImageObserver() {
      if (window.innerWidth <= 991) {
        this.observeImageHeight(this.image);
      }
    }

    observeImageHeight(img) {
      if (!img) return;

      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const less = window.innerWidth <= 768 ? 90 : 180
          const height = entry.contentRect.height - less;
          this.blendComponent.style.height = height + "px";
        }
      });

      resizeObserver.observe(img);
    }
  }

  customElements.define("image-with-icons", ImageWithIcons);
}
